import { createContext, useEffect, useMemo, useState } from "react";

import { Auth } from "../api";
import {
  getAccessToken,
  getUser,
  removeAccessToken,
  removeUser,
  setAccessToken,
  setUser,
} from "../utils";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedToken = getAccessToken();
    const storedUser = getUser();

    if (storedToken && storedUser) {
      setUserState(storedUser);
    } else {
      removeAccessToken();
      removeUser();
    }

    setIsLoading(false);
  }, []);

  async function login(data) {
    const authController = new Auth();

    const result = await authController.login(data);

    /*
      El backend responde:
      {
        accessToken: "...",
        user: {
          _id, name, email, role
        }
      }
    */
    setAccessToken(result.accessToken);
    setUser(result.user);
    setUserState(result.user);

    return result;
  }

  function logout() {
    removeAccessToken();
    removeUser();
    setUserState(null);
  }

  const valueContext = useMemo(
    () => ({
      user,
      isLoading,
      login,
      logout,
    }),
    [user, isLoading]
  );

  return (
    <AuthContext.Provider value={valueContext}>
      {children}
    </AuthContext.Provider>
  );
}